

























































































































































































































































































import _ from "lodash";
import { FormsApi, PatientApi, NewCustomerRequest, Gender } from "@/api";
import stateMixin from "@/mixins/state";
import { toLocalDateString } from "@/util/date";

interface InitialFields {
  extraScroll: Boolean;
  startDate: Date | null;
  amountOfDays: Number | null;
  orderReceiveDate: Date | null;
  deliveryDate: Date | null;
  receiveReturnCall: Boolean;
  isNewCustomer: Boolean;
  newCustomer: NewCustomerRequest | null;
}

const initialFields: InitialFields = {
  extraScroll: false,
  startDate: null,
  amountOfDays: null,
  orderReceiveDate: null,
  deliveryDate: null,
  receiveReturnCall: false,
  isNewCustomer: false,
  newCustomer: null
};
// Import Vue FilePond
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
// Import the File Type Validation plugin
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

// Create component
const FilePond = vueFilePond(FilePondPluginFileValidateType);

export default {
  data() {
    return {
      valid: true,
      toLocalDateString,
      autocomplete: {
        entries: [],
        isLoading: false,
        model: null,
        search: null,
        error: false
      },

      fields: { ...initialFields },
      rules: {
        startDate: [v => !!v || "Startdatum is verplicht"],
        amountOfDays: [v => !!v || "Aantal dagen is verplicht"],
        sendDate: [v => !!v || "Verzenddatum is verplicht"],
        receiveDate: [v => !!v || "Ontvangdatum is verplicht"],
        patient: [v => !!v || "Patient is verplicht"],
        deliveryDate: [v => !!v || "Ontvangsdatum is verplicht"],
        orderReceiveDate: [v => !!v || "Verstuurdatum is verplicht"],
        birthDate: [v => !!v || "Geboortedatum is verplicht"],
        initials: [v => !!v || "Initialen zijn verplicht"],
        lastName: [v => !!v || "Achternaam is verplicht"],
        gender: [v => !!v || "Geslacht is verplicht"]
      },
      startDateMenu: null,
      sendDateMenu: null,
      receiveDateMenu: null,
      birthDateMenu: false,
      birthDate: "",
      birthDateFormatted: "",

      minStartDate: "",

      minOrderReceiveDate: "",
      maxOrderReceiveDate: "",

      maxOrderDeliveryDate: "",
      minOrderDeliveryDate: "",

      myFiles: null,

      filePond: {
        files: null,
        server: {
          url: process.env.VUE_APP_API,
          process: {
            url: "/api/portal/File/UploadFile",
            method: "POST",
            headers: {
              Authorization: ""
            }
          }
        }
      }
    };
  },
  mixins: [stateMixin],
  components: {
    FilePond
  },
  methods: {
    submit: async function() {
      this.$refs.form.validate();
      if (this.valid) {
        this.setState(this.states.LOADING);
        const api = new FormsApi();
        try {
          if (this.fields.isNewCustomer === true) {
            this.autocomplete.model = null;
          }
          const result = await api.formsRequestImmediateProduct({
            patientId: this.autocomplete.model?.patientId,
            extraScrollIsHolidayScroll: this.fields.extraScroll,
            startDate: this.fields.startDate,
            amountOfDays: this.fields.amountOfDays,
            sendDate: this.fields.orderReceiveDate,
            receiveDate: this.fields.deliveryDate,
            fileGuid: this.fields.fileGuid,
            receiveReturnCall: this.fields.receiveReturnCall,
            newCustomer: this.fields.newCustomer
          });
          this.setState(this.states.COMPLETED);
          (this.$refs.form as HTMLFormElement).reset();
          this.fields = { ...initialFields };
          this.$refs.pond.removeFiles();
        } catch {
          this.setState(this.states.ERROR);
        }
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("-");
      this.birthDate = `${year}-${month.padStart(2, "0")}-${day.padStart(
        2,
        "0"
      )}`;

      this.updateBirthDate();
    },
    getDateIso: function(date) {
      const month = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      return `${date.getFullYear()}-${month}-${day}`;
    },
    updateBirthDate: function() {
      const birthDate = new Date(this.birthDate);
      if (this.birthDate && this.fields.newCustomer) {
        this.fields.newCustomer.birthDate = this.getDateIso(birthDate);
      }
    },
    updateReceiveDatepicker: function() {
      const delivery = new Date(this.fields.deliveryDate);
      const receive = new Date(this.fields.orderReceiveDate);
      const start = new Date(this.fields.startDate);

      const TODAY = Date.now();
      const ONE_DAY = 24 * 60 * 60 * 1000;

      if (delivery > start) this.fields.deliveryDate = null;
      if (receive >= start || receive >= delivery)
        this.fields.orderReceiveDate = null;

      this.minStartDate = this.getDateIso(new Date(TODAY + ONE_DAY));

      if (start) {
        this.minOrderDeliveryDate = this.getDateIso(new Date(TODAY + ONE_DAY));
        this.maxOrderDeliveryDate = this.getDateIso(new Date(start.getTime()));
      }

      if (delivery) {
        this.minOrderReceiveDate = this.getDateIso(new Date(TODAY));
        this.maxOrderReceiveDate = this.getDateIso(
          new Date(delivery.getTime() - ONE_DAY)
        );
      }
    },
    handleFilePondInit() {
      this.filePond.server.process.headers[
        "Authorization"
      ] = `Bearer ${this.$store.getters["auth/getAuth"].accessToken}`;
    },
    processUploadedFile(err, file) {
      this.fields.fileGuid = file.serverId;
    },
    createNewCustomer() {
      if (this.fields.newCustomer !== null) {
        this.fields.newCustomer = null;
        return;
      }
      this.fields.newCustomer = {
        initials: "",
        lastName: "",
        birthDate: "",
        gender: Gender.Male
      };
    },
    closeBirhtDateMenuKeepFocus() {
      this.birthDateMenu = false;
      document.getElementById("birthDateField")?.focus();
    }
  },
  computed: {
    currentDate() {
      const date = new Date(Date.now());
      const month = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      return `${date.getFullYear()}-${month}-${day}`;
    },
    computedDateFormatted() {
      return this.formatDate(this.birthDate);
    }
  },
  watch: {
    "autocomplete.search": _.debounce(function(val) {
      if (!val) {
        return;
      }
      if (val.length < 2) {
        return;
      }

      let self = this;
      this.autocomplete.isLoading = true;
      this.autocomplete.error = true;

      const api = new PatientApi();
      api
        .patientSearchPatients({
          filter: val
        })
        .then(function(res) {
          self.autocomplete.entries = res.data;
          self.autocomplete.isLoading = false;
          self.autocomplete.error = false;
        })
        .catch(function(err) {
          self.autocomplete.isLoading = false;
          self.autocomplete.error = true;
        });
    }, 1000),
    birthDate(val) {
      this.birthDateFormatted = this.formatDate(this.birthDate) || "";
    }
  }
};
